if (!customElements.get('order-lookup')) {
  class OrderLookup extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.submitButton = this.form.querySelector('button[type="submit"]');
      this.input = this.form.querySelector('input[name="order-number"]');
      this.orderNumberEls = this.querySelectorAll('[data-order-number]');
      this.applicationNumberEls = this.querySelectorAll('[data-application-number]');

      console.log(this.form , "触发form");

      this.notFound = this.querySelector('[data-not-found]');
      this.approved = this.querySelector('[data-approved]');
      this.pending = this.querySelector('[data-pending]');
      this.rejected = this.querySelector('[data-rejected]');
      this.blank = this.querySelector('[data-blank]');

      if (this.form) {
        this.form.addEventListener('submit', this.handleSubmit.bind(this));
      }
    }

    // JSONP 请求封装
    fetchJsonp(url) {
      return new Promise((resolve, reject) => {
        const callbackName = `jsonp_callback_${Math.round(100000 * Math.random())}`;
        const script = document.createElement('script');

        window[callbackName] = (data) => {
          resolve(data);
          delete window[callbackName];
          document.body.removeChild(script);
        };

        script.src = `${url}${url.includes('?') ? '&' : '?'}callback=${callbackName}`;

        console.log(callbackName ,  script.src , 'callbackName')

        
        script.onerror = () => {
          reject(new Error('JSONP 加载失败'));
          delete window[callbackName];
          document.body.removeChild(script);
        };

        document.body.appendChild(script);
      });
    }

    async handleSubmit(event) {
      event.preventDefault();

      try {
        this.submitButton.disabled = true;
        this.submitButton.classList.add('loading');

        const orderNumber = this.input.value;

        // 调用 JSONP 请求，传入 orderNumber 拼接的 URL
        // const data = await this.fetchJsonp(`http://43.128.249.6:8668/googleSheet/query/v2/${orderNumber}?callback=serviceOrder`);
         const data = await this.fetchJsonp(`https://wms.yioumai.cn/googleSheet/query/v2/${orderNumber}`);

        const { serviceOrder } = data;

        console.log("serviceOrder" , serviceOrder)
        
        if (data.status === 'not-found') {
          this.onNotFound();  
        } else if (data.status === 'approved') {
          this.onSuccess();
        } else if (data.status === 'pending') {
          this.onPending();
        } else if (data.status === 'rejected') {
          this.onRejected();
        }
        console.log("orderNumber" , orderNumber)
        this.orderNumberEls.forEach((el) => {
          el.innerHTML = orderNumber;
        });
      
        console.log("applicationNumber" , data.applicationNumber)
        this.applicationNumberEls.forEach((el) => {
          el.innerHTML = data.applicationNumber ? `【Application Number：${data.applicationNumber}】` : '';
        });
      } catch (error) {
        console.error('JSONP 请求失败:', error);
      } finally {
        this.submitButton.disabled = false;
        this.submitButton.classList.remove('loading');
      }
    }

    onSuccess() {
      this.approved.style.display = 'flex';

      this.notFound.style.display = 'none';
      this.pending.style.display = 'none';
      this.rejected.style.display = 'none';
      this.blank.style.display = 'none';
    }

    onPending() {
      this.pending.style.display = 'flex';

      this.notFound.style.display = 'none';
      this.approved.style.display = 'none';
      this.rejected.style.display = 'none';
      this.blank.style.display = 'none';
    }

    onRejected() {
      this.rejected.style.display = 'flex';

      this.notFound.style.display = 'none';
      this.approved.style.display = 'none';
      this.pending.style.display = 'none';
      this.blank.style.display = 'none';
    }
    
    onNotFound() {
      this.notFound.style.display = 'flex';

      this.approved.style.display = 'none';
      this.pending.style.display = 'none';
      this.rejected.style.display = 'none';
      this.blank.style.display = 'none';
    }
  }

  customElements.define('order-lookup', OrderLookup);
}
